import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SupplierContractChecksStore } from '../stores/supplier-contract-checks.store';

export const supplierContractChecksLoadedGuard: CanActivateFn = () => {
  const checksStore = inject(SupplierContractChecksStore);
  if (!checksStore.allLoaded() && !checksStore.isLoading() && !checksStore.error()) {
    checksStore.load();
  }
  return true;
};
